import { Component, Input } from '@angular/core';
import { NavParams, PopoverController, Platform } from '@ionic/angular';

import { AuthService } from '../../service/auth.service';

@Component({
    selector: 'app-sort-popover',
    templateUrl: './sort-popover.page.html',
    styleUrls: ['./sort-popover.page.scss'],
})
export class SortPopoverPage
{
    private hide = false;
    private type = "1";
    private sort_folder = 0;
    private order = null;
    private sort = null;
    private resize = null;

    private type_group = {
        file_name: {ASC: "1", DESC: "2"},
        file_mtime: {ASC: "3", DESC: "4"},
    };

    constructor(
        private popover: PopoverController,
        private navParams: NavParams,
        private platform: Platform,
        private auth: AuthService
    )
    {
    }

    async ngOnInit()
    {
        this.resize = this.platform.resize.subscribe(() => {
            this.popover.dismiss();
        });

        this.order = this.navParams.data.order;
        this.sort = this.navParams.data.sort;
        this.sort_folder = this.navParams.data.sort_folder;
        this.hide = this.navParams.data.hide;

        if (!this.auth.empty(this.order)) {
            this.type = this.type_group[this.order][this.sort];
        }
    }

    ngOnDestroy()
    {
        if (this.resize == null) return;
        this.resize.unsubscribe();
        this.resize = null;
    }

    sortOnChangeToggle(event)
    {
        this.sort_folder = (event.target.checked ? 1 : 0);
        this.popover.dismiss({ order: this.order, sort: this.sort, sort_folder: this.sort_folder });
    }

    setSort(type)
    {
        switch (type) {
            case "1":
                this.order = "file_name";
                this.sort = "ASC";
                break;
            case "2":
                this.order = "file_name";
                this.sort = "DESC";
                break;
            case "3":
                this.order = "file_mtime";
                this.sort = "ASC";
                break;
            case "4":
                this.order = "file_mtime";
                this.sort = "DESC";
                break;
            default:
                break;
        }

        this.popover.dismiss({ order: this.order, sort: this.sort, sort_folder: this.sort_folder });
    }
}
